<template>
  <el-dialog class="d-tree" :title="title" :visible.sync="show" :center="true" width="50%" :append-to-body="true" :destroy-on-close="true">
    <div style="width: 100%; height: 100%;" v-loading="loading">
      <el-tree ref="tree" :data="tree.data" show-checkbox node-key="id" :default-expand-all="true" @check="checkFn" :check-on-click-node="true" :indent=30
        :props="tree.props" style=" height: 520px; overflow-y: auto; padding-bottom: 10px;">
      </el-tree>
      <div slot="footer" class="dialog-footer">
        <el-button @click="show = false">取 消</el-button>
        <el-button @click="save" type="primary" :disabled="abled">保 存</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: "Error",
    props: [],
    components: {},
    data() {
      return {
        ids: "",  // 默认选中的角色id
        show: false,
        loading: false,
        title: '',
        abled: true,
        tree: {
          data: [],
          props: {
            children: 'children',
            label: 'name'
          },
          check: ""
        }
      };
    },
    computed: {},
    created() {},
    mounted() {},
    destroyed() {},
    methods: {
      // 显示弹框
      dialogShow(ids) {
        this.title = "选择角色";
        this.show = true;
        this.ids = ids;
        this.getRoleData();
      },
      // 请求角色
      getRoleData() {
        this.loading = true;
        this.$http
          .get("/web/roleList")
          .then(({ data }) => {
            if (data.resCode === 0) {
              let arr = [{ id: 'all', name: "全部", children: [] }];
              arr[0].children = data.resData;
              this.tree.data = arr;

              // 设置默认选中角色
              this.$nextTick( () => {
                if (this.ids) {
                  this.$refs.tree.setCheckedKeys(this.ids.split(","));
                  this.tree.check = this.ids.split(",");
                  this.abled = false;
                }
              })
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      },
      // 触发复选框
      checkFn () {
        let arr = this.$refs.tree.getCheckedKeys();
        if ( arr[0] === "all") {
          this.tree.check = 'all';
        } else {
          this.tree.check = arr.join(",");
        }
        this.abled = arr.length > 0 ? false : true;
      },
      // 保存选中的角色
      save () {
        setTimeout( () => {
          this.show = false;
          this.$message.success("选择成功！");
        },500)
      },
      // 获取复选框的值
      getValFn () {
        return this.tree.check;
      }
    },
    watch: {},
    filters: {}
  };
</script>

<style scoped>
  .dialog-footer {
    text-align: center;
  }
</style>
